export default {
    virtual_assistant: 'Virtual assistant',
    chat_with_edha: 'Chat with Edha',
    enter_question: 'Choose one of the following options',
    edha_chat: {
        default: 'Hi! I am Edha your MedMatch Network virtual assistant. Choose from the following options to get started:',
        question_types: {
            header_1: 'Differential diagnosis',
            chatGptQuestion_1:
                'Act as a medical assistant; Provide different diagnosis; use sources from the CDC, FDA and Pubmed sites, and medical journals only; provide citations',
            question_1: 'Enter Symptoms',
            placeholder_1: 'Enter your symptoms',
            context_1: 'differential-diagnosis',

            header_2: 'Medical questions',
            chatGptQuestion_2:
                'Act as a medical research assistant; elaborate on the following medication condition; provide citations; use sources from the CDC, FDA and pubmed sites, and medical journals only; provide citations',
            question_2: 'Enter question',
            placeholder_2: 'Enter your question',
            context_2: 'medical-questions',

            header_3: 'Medication Interraction',
            chatGptQuestion_3:
                'Act as a medical assiatant; provide any Drug interractions for the following medications; use sources from the CDC, FDA and pubmed sites, and medical journals only; provide citations',
            question_3: 'Enter medications; at least 2',
            placeholder_3: 'Enter your medications',
            context_3: 'medication-interactions',

            header_4: 'Indications',
            chatGptQuestion_4:
                'Act as a medical assistant; Provide indications treatment recommendation for [condition]; use sources from the CDC, FDA and Pubmed sites, and medical journals only; provide citations',
            question_4: 'Enter Conditions',
            placeholder_4: 'Enter your conditions',
            context_4: 'indications',
        },
    },
}
